<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='考核表设置' url='/basicInfo/evaluation/list'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.etname' label='名称'></SearchNormalText>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 80px;text-align:right;">考核表类型：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.ettype" filterable placeholder="全部">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <!-- <AddButton url="/basicInfo/evaluation/add" buttonname="新增"></AddButton> -->
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="ETName" label="名称">
            </el-table-column>
            <el-table-column prop="ETRemark1" label="类别">
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
                <el-button @click="Detail(scope.row)" type="text" size="medium">详情</el-button>
                <el-button @click="Detele(scope.row)" type="text" size="medium" style="color: red;display: none;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <!--begin: Pager -->
          <div style="margin-top: 10px;text-align: center;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
          <!--end: Pager -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EvaluationList',
    data() {
      return {
        condition: {
          etname: '',
          ettype: '',
          token: sessionStorage.getItem('token'),
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        options: [{
          value: '',
          label: '全部'
        },{
          value: '1',
          label: '学员考核表'
        }, {
          value: '2',
          label: '带教老师考核表'
        }, {
          value: '3',
          label: '科秘书考核表'
        }],
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APIExamTable/List',
        loading: true
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      Edit: function(row) {
        this.$router.push({
          name: 'EvaluationEdit',
          params: {
            id: row.ETID,
            etname: row.ETName,
            ettype: row.ETType
          }
        })
      },
      Detele: function(row) {
        console.log(row.ETID)
        var args = {
          id: row.ETID,
          token: this.condition.token
        }
        this.$utils.Delete(this.$utils.Url.zpgl + '/api/APIExamTable/Delete', args, row.ETName, this.$refs.btnSearch.Search)
      },
      Detail: function(row) {
        this.$router.push({
          name: 'EvaluationInfo',
          params: {
            id: row.ETID,
            etname: row.ETName,
            ettype: row.ETRemark1
          }
        })
      }
    },
    mounted: function() {
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style>
</style>
